import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {CategoryInputOutput} from "./category-input-output";

/**
 * POST /api/v1/admin/member/category-groups の
 * リクエストボディ用クラス
 */
@JsonObject("CategoryGroupInput")
export class CategoryGroupInput {
    @JsonProperty("slug", String)
    public slug: string = JsonPropertyEmpty;

    @JsonProperty("label", String)
    public label: string = JsonPropertyEmpty;

    @JsonProperty("categories", [CategoryInputOutput])
    public categories: CategoryInputOutput[] = JsonPropertyEmpty;

    public constructor(args?: Partial<CategoryGroupInput>) {
        Object.assign(this, args);
    }
}
